<template>
    <thead class="main-table__header">
        <th v-for="column in columns" class="main-table__header-item">
            <span id="created_at" @click="(e) => {column.onClick ? column.onClick(e) : ''}" class="table-header-sort noselect">
                <span>
                    {{ column.label }}
                </span>
                <span v-if="column.onClick" class="sort-col-wrapper">
                    <inline-svg
                        class="sort-icon sort-icon-desc"
                        src="/images/up-arrow.svg" aria-label="PPCShield">
                    </inline-svg>
                    <inline-svg
                        class="sort-icon sort-icon-down sort-icon-asc"
                        src="/images/up-arrow.svg" aria-label="PPCShield">
                    </inline-svg>
                </span>
            </span>
        </th>
    </thead>
</template>

<script>
    export default {
        name: 'table-header',
        props: {
            columns: {
                type: [Array],
            },
        },
        data: function () {
            return {

            }
        },
        mounted() {
        }
    }
</script>
